import React from "react";
import JourneyCard from "../../common/journey_card/JourneyCard";
import "./UCJourney.css";
import data from "../../../configs/uc-journey/journey.json";
import Carousel from "../../common/carousel/Carousel";

export default function UCJourney() {
  return (
    <div className={"UCJourney-wrapper"} id="UCJourney-cards">
      <div className={"UCJourney-screen"}>
        <header className={"UCJourney-heading"}>Urban Company’s journey</header>
        <div className={"UCJourney-cards"}>
          {window.innerWidth > 600 &&
            data.journey.map((journey) => {
              return (
                <JourneyCard
                  heading={journey.heading}
                  text={journey.text}
                  containerStyle={journey.containerStyle.desktop}
                />
              );
            })}
          {window.innerWidth <= 600 && (
            <Carousel
              items={1}
              size={data.journey.length}
              showDot={true}
              showArrow={true}
              width={343}
            >
              {data.journey.map((journey) => {
                return (
                  <JourneyCard
                    heading={journey.heading}
                    text={journey.text}
                    containerStyle={journey.containerStyle.mobile}
                  />
                );
              })}
            </Carousel>
          )}
        </div>
      </div>
    </div>
  );
}
